import React from 'react';
import "babel-polyfill";
import i18n from 'i18n-js';

import Check from "./Check";
import UserMenu from "./UserMenu";
import LoginPage from "../containers/LoginPageContainer";
import FirmsContainer from "../containers/FirmsContainer";
import InboxPageContainer from "../containers/InboxPageContainer";
import SmsPageContainer from "../containers/SmsPageContainer";
import DashboardContainer from "../containers/DashboardContainer";
import WeeklyReportPage from "./WeeklyReportPage";
import RAsheetsContainer from "../containers/RAsheetsContainer";
import OBSsheetsContainer from "../containers/OBSsheetsContainer";
import RiskAssessmentContainer from "../containers/RiskAssessmentContainer";
import ServerStatsPageContainer from "../containers/ServerStatsPageContainer";
import OldRiskAssessmentContainer from "../containers/OldRiskAssessmentContainer";
import UsersContainer from "../containers/UsersContainer";
import ObservationContainer from "../containers/ObservationContainer";
import SubPageContainer from "../containers/SubPageContainer";
import UserInfoPageContainer from "../containers/UserInfoPageContainer";
import SettingsPageContainer from "../containers/SettingsPageContainer";
import PrintPageContainer from "../containers/PrintPageContainer";
import GroupsPageContainer from "../containers/GroupsPageContainer";
import SheetPageContainer from "../containers/SheetPageContainer";
import LogPageContainer from "../containers/LogPageContainer";
import ServerPageContainer from "../containers/ServerPageContainer";
import LocalePageContainer from "../containers/LocalePageContainer";
import PublicReportContainer from "../containers/PublicReportContainer";
import MultiPrintPublicContainer from "../containers/MultiPrintPublicContainer";
import { Router, Route } from 'react-router';
import store, { history } from '../store';
import {api, IP} from "./baseFunctions";
import world from "./images/world-map5.svg";


i18n.translations = {};
i18n.defaultLocale = "en-US";
i18n.locale = window.navigator.language;
i18n.fallbacks = true;
i18n.missingTranslation = langKey => langKey; // Temp

class App extends React.Component {
  int = null;
  state = {
    langData: 0
  };
  componentDidMount()
  {
    this.checkLastSync();
    this.int = setInterval(() => {
      if(this.props.auth)
      {
        api("POST", {"type": "sync"}, (d) => {
          if(!d.error)
          {
            store.dispatch({
              type: 'UPD_GROUPS',
              data: d.data
            });
          }
        }, this.props.auth);
        localStorage.setItem("lastSync", Date.now());
      }
    }, 1000 * 60 * 3);

    api("POST", {"type": "getLocales", "short": true}, (d) => {
      if(!d.error)
      {
        i18n.translations = d.data;
        this.setState({
          langData: this.state.langData + 1
        });
      }
    });
  }

  checkLastSync(){
    const lastSync = localStorage.getItem("lastSync") || "0";
    const check = (Date.now() - Number(lastSync)) > 1000 * 60 * 30;
    if(check)
    {
      store.dispatch({
        type: "UPD_AUTH",
        data: 0
      });
      document.body.className = "login";
    }
  }
  render() {
    if(this.props.auth)
    {
      document.body.className = "nav-md";
    }
    if(this.props.justLogged && this.props.auth)
    {
      setTimeout(() => store.dispatch({
          type: 'UPD_FIRST_LOGIN',
          data: 0
        }), 800);
    }
    const RELOAD = () => {
      console.log("Reloading!");
      window.location.reload();
    };
    console.log("HMM", this.props);
    return (
    <div className="container body">
      <div className="main_container">
        <Check stmt={this.props.auth}>
          <UserMenu key={Math.random()*10000 + window.location} logo={this.props.fID} auth={this.props.auth} groups={this.props.groups} otherDepartments={this.props.otherDepartments} modules={this.props.modules} rank={this.props.rank} lang={this.props.lang}/>
          <img src={world} style={{display: "none"}} alt="world"/>
        </Check>

        <div className={this.props.justLogged && this.props.auth ? "coolLoader" : "coolLoader hidden"}>
          <img src={IP + "/logo/"  + this.props.fID} alt="loader" className="coolLogo"/>
        </div>
        <Router key={(this.props.auth ? this.props.auth.length : 0) + "-" + this.state.langData} history={history} onUpdate={() => window.scrollTo(0, 0)}>

          <Route path="/report/:hash/:lang" component={WeeklyReportPage}/>
          <Route path="/publicReport/:id/:lang/:hash" component={PublicReportContainer}/>
          <Route path="/multiPublicReport/:lang/:datas" component={MultiPrintPublicContainer}/>
          <Route path="/publicReport/:id/:lang/:hash/:otherhash" component={PublicReportContainer}/>
          <React.Fragment key={this.props.auth.length}>
            {
              !!this.props.auth ? 
              <div>

                {/*<Route path="/otherFiles/:rnd" onEnter={RELOAD}/>*/}
                <Route path="/print/:type/:from/:to" component={PrintPageContainer}/>
                <Route path="/print/:type/:from/:to/:extra" component={PrintPageContainer}/>


                <Route path="/sms" component={SmsPageContainer}/>
                
                <Route path="/inbox" component={InboxPageContainer}/>
                <Route path="/inbox/new" component={InboxPageContainer}/>
                <Route path="/inbox/read/:id" component={InboxPageContainer}/>

                <Route path="/firms" component={FirmsContainer}/>
                <Route path="/firms/new" component={FirmsContainer}/>
                <Route path="/firms/edit/:id" component={FirmsContainer}/>

                <Route path="/user/:id" component={UserInfoPageContainer}/>

                <Route path="/sub" component={SubPageContainer}/>
                <Route path="/sub/:id" component={SubPageContainer}/>

                <Route path="/reports/:group" component={ObservationContainer}/>
                <Route path="/reports/:group/:id" component={ObservationContainer}/>

                <Route path="/oldRa" component={OldRiskAssessmentContainer}/>
                <Route path="/oldRa/:id" component={OldRiskAssessmentContainer}/>

                <Route path="/users" component={UsersContainer}/>
                <Route path="/users/newDepartment" component={UsersContainer}/>
                <Route path="/users/new" component={UsersContainer}/>
                <Route path="/users/edit/:id" component={UsersContainer}/>
                <Route path="/users/edit/department/:id" component={UsersContainer}/>
                <Route path="/users/gen-qr/:uid" component={UsersContainer}/>

                <Route path="/ra" component={RiskAssessmentContainer}/>
                <Route path="/ra/:id" component={RiskAssessmentContainer}/>
                <Route path="/raSheet" component={RAsheetsContainer}/>
                <Route path="/raSheet/new" component={RAsheetsContainer}/>
                <Route path="/raSheet/edit/:id/:key" component={RAsheetsContainer}/>

                <Route path="/obsSheet" component={OBSsheetsContainer}/>
                <Route path="/obsSheet/new" component={OBSsheetsContainer}/>
                <Route path="/obsSheet/edit/:id" component={OBSsheetsContainer}/>
                
                <Route path="/groups" component={GroupsPageContainer}/>
                <Route path="/sheets" component={SheetPageContainer}/>
                <Route path="/locale" component={LocalePageContainer}/>

                <Route path="/serverStats" component={ServerStatsPageContainer}/>

                <Route path="/log" component={LogPageContainer}/>
                <Route path="/settings" component={SettingsPageContainer}/>
                <Route path="/server" component={ServerPageContainer}/>

                <Route path="*" component={DashboardContainer}/>
              </div> 
              : <Route path="*" component={LoginPage}/>
            }
          </React.Fragment>
        </Router>
      </div>
    </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js